import type { User } from "@investhinks/api-client";
import { createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";

function isUser(value: unknown): value is User {
  return typeof value === "object" && value !== null && "email" in value;
}

// Transform to strip large nested objects from user before persisting
const userTransform = createTransform(
  // Transform state on its way to being serialized and persisted
  (inboundState: unknown, key) => {
    if (key === "user" && isUser(inboundState)) {
      // Only keep essential user fields - serialization boundary from redux-persist
      return {
        id: inboundState.id,
        username: inboundState["username"],
        email: inboundState.email,
        name: inboundState.name,
        role: inboundState.role,
        isVIP: inboundState.isVIP,
        isTest: inboundState.isTest,
        referrerType: inboundState.referrerType,
        country: inboundState["country"],
        mainCurrency: inboundState["mainCurrency"],
        language: inboundState["language"],
        confirmed: inboundState["confirmed"],
        blocked: inboundState["blocked"],
      };
    }
    return inboundState;
  },
  // Transform state being rehydrated (no change needed)
  (outboundState) => outboundState,
  // Only apply to these keys
  { whitelist: ["user"] }
);

const statePersistConfig = {
  key: "session",
  storage,
  blacklist: ["extendedMode"],
  transforms: [userTransform],
};

export default statePersistConfig;
